<template>
    <div>
        <v-container
                fluid
                grid-list-xs
                class="pa-3"
                style="background: #333 !important; color: #FFF !important; height: 100%;"
                v-if="grupo && Object.keys(grupo).length && base && Object.keys(base).length">
            <v-layout row wrap class="pb-3">
                <v-flex xs3 class="pt-2">
                    <v-icon dark class="d-inline" @click="regresarBases">apps</v-icon>
                </v-flex>
                <v-flex xs6>
                    <h2 class="text-xs-center">{{ base.nombre }}</h2>
                </v-flex>
                <v-flex xs3></v-flex>
            </v-layout>
            <v-layout row wrap v-if="tablas && Object.keys(tablas).length" style="height: 92%;">
                <v-flex xs12 style="height: 100%;">
                    <v-tabs
                            light
                            color="white"
                            show-arrows
                            v-model="selectedTab"
                            style="height: 100%;"
                    >
                        <v-tabs-slider color="black"></v-tabs-slider>

                        <v-menu
                                bottom
                                class="v-tabs__div"
                                offset-y>
                            <a slot="activator" class="v-tabs__item">
                                <v-icon>menu</v-icon>
                            </a>

                            <v-list class="grey lighten-3">
                                <v-list-tile v-for="(tabla, index) in tablas.tablas" :key="index" v-if="tabla" @click="selectedTab = 'tab-' + index">
                                    {{ tabla.nombre }}
                                </v-list-tile>
                                <v-list-tile>
                                    <v-text-field label="Agregar tabla"
                                                  v-model="nuevaTabla"
                                                  @click.stop
                                                  color="black"
                                                  @keyup.enter="agregar({base: base.base})"></v-text-field>
                                </v-list-tile>
                            </v-list>
                        </v-menu>

                        <v-tab
                                v-for="(tabla, index) in tablas.tablas" v-if="tabla"
                                :href="'#tab-' + index"
                                :key="index"
                                style="height: 100%;"
                        >
                            {{ tabla.nombre }}
                        </v-tab>

                        <v-tabs-items style="height: 100%;">
                            <v-tab-item
                                    v-for="(tabla, index) in tablas.tablas" v-if="tabla"
                                    :id="'tab-' + index"
                                    :key="index"
                                    style="height: 100%;"
                                    lazy
                            >
                                <v-card flat style="height: 100%;">
                                    <v-card-title class="pb-0 pt-0" style="border-bottom: 1px solid #EBEBEB; border-top: 1px solid #EBEBEB;">
                                        <v-select
                                                :items="vistas"
                                                v-model="vistaSeleccionada"
                                                class="mr-3 d-block"
                                                dense
                                                menu-props="offsetY"
                                                color="black"
                                        ></v-select>

                                        <v-menu offset-y>
                                            <v-btn slot="activator" small>Ocultar Campos</v-btn>
                                            <v-list dense>
                                                <v-list-tile v-for="(campo, i) in campos" :key="i" @click.stop>
                                                    <v-switch v-model="camposSeleccionados" :label="campo" :value="campo" color="black">{{campo}}</v-switch>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>

                                        <v-menu offset-y>
                                            <v-btn slot="activator" icon><v-icon>more_horiz</v-icon></v-btn>
                                            <v-list dense>
                                                <v-list-tile @click="borrar(tabla)">Borrar Tabla</v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </v-card-title>
                                    <v-card-text>
                                        <pre>{{ grupo }}</pre>
                                        <pre>{{ base }}</pre>
                                        <pre>{{ tabla }}</pre>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
  import {mapState, mapActions} from 'vuex'

  export default {
    name: 'base_detalle',
    data() {
      return {
        base: {grupo: null},
        grupo: [],
        vistas: [
          'Grid View', 'Vista de Prueba'
        ],
        vistaSeleccionada: 'Grid View',
        campos: [
          'nombre', 'nomenclatura'
        ],
        camposSeleccionados: [
          'nombre', 'nomenclatura'
        ],
        nuevaTabla: '',
        selectedTab: 'tab-1',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
      }
    },
    props: ['idBase'],
    methods: {
      ...mapActions('bases', ['obtenerGrupos', 'obtenerBases']),
      ...mapActions('tablas', ['obtenerTablas', 'agregarTabla', 'borrarTabla']),
      ...mapActions(['cambiarTitulo']),
      obtenerDatos() {
        this.obtenerBases()
        this.obtenerGrupos()

        setTimeout(this.inicializar, 1000)
      },
      inicializar() {
        this.base = this.bases.bases[this.$route.params.idBase]
        this.grupo = this.bases.grupos[this.base.grupo]
        this.obtenerTablas(this.base.base)
        this.cambiarTitulo('Base')
      },
      agregar(tabla) {
        if(this.nuevaTabla && this.nuevaTabla.length) {
          tabla.nombre = this.nuevaTabla
          this.agregarTabla(tabla)
          this.nuevaTabla = ''
        }
      },
      borrar(tabla) {
        this.borrarTabla(tabla)
      },
      regresarBases() {
        this.$router.push({path:'/bases/inicio'});
      },
    },
    computed: {
      ...mapState({bases: state => state.bases}),
      ...mapState({tablas: state => state.tablas})
    },
    mounted() {
      if (Object.keys(this.bases.bases).length === 0) {
        this.obtenerDatos()
      } else {
        this.inicializar()
      }
    }
  }
</script>
<style>
    .v-tabs__div {
        text-transform: none !important;
    }

    .d-block {
        display: block !important;
        -webkit-box-flex: 0 !important;
        flex: unset !important;
    }
</style>